import { render, staticRenderFns } from "./ShowMoreOverlay.vue?vue&type=template&id=8f1c5f84&scoped=true&"
import script from "./ShowMoreOverlay.vue?vue&type=script&lang=ts&"
export * from "./ShowMoreOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./ShowMoreOverlay.vue?vue&type=style&index=0&id=8f1c5f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1c5f84",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsChevronUpIcon24px: require('/var/www/packages/theme/components/icons/chevron-up/ChevronUpIcon24px.vue').default,IconsChevronDownIcon24px: require('/var/www/packages/theme/components/icons/chevron-down/ChevronDownIcon24px.vue').default,AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default})
